export default __webpack_public_path__ + "static/media/sowmz-new.720228db.jpg";